import React, { FC } from 'react';
import { SVGTooltipProps } from '@utils';
import { SvgWithTooltip } from '../SvgWithTooltip';

export const Telephone: FC<SVGTooltipProps> = ({ onClick, divClassName, tooltip }) => (
  <SvgWithTooltip
    onClick={onClick}
    divClassName={divClassName}
    tooltip={tooltip}
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 500 500"
    >
      <g>
        <path d="M366.667,300c-33.334,33.333-33.334,66.666-66.667,66.666S233.333,333.333,200,300
          c-33.333-33.334-66.667-66.667-66.667-100c0-33.333,33.333-33.333,66.667-66.667S133.333,0,100,0S0,100,0,100
          c0,66.667,68.49,201.823,133.333,266.667S333.333,500,400,500c0,0,100-66.667,100-100C500,366.667,400,266.667,366.667,300z"
        />
      </g>
    </svg>
  </SvgWithTooltip>
);
